import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

function DepreciationRateContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  depreciationRateId,
  showData,
  dataInfo,
  permissions,
}) {
  useEffect(() => {
    if (_.isEmpty(depreciationRateId)) return;
    showData(depreciationRateId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(depreciationRateId)) return;
    showData(depreciationRateId);
  }, [depreciationRateId]);

  return (
    <div className="d-flex flex-column h-100">
      {Acl(permissions, ['CREATE E2E RPT MACHINERY DEPRECIATION RATES']) && (
        <div className="row mb-3">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
            style={{ marginRight: 30 }}
          >
            <i className="fas fa-plus" />
            <span className="ml-2">Add Depreciation Rate</span>
          </button>
        </div>
      )}
      <div className="ml-3 p-3 card right-section h-100">
        {!_.isEmpty(dataInfo) ? (
          <React.Fragment>
            <div className="row d-flex justify-content-between align-items-center">
              <div className="col-10">
                <h3 className="mb-0">Information</h3>
              </div>
              <div className="col-2 d-flex align-items-end justify-content-end">
                {Acl(permissions, [
                  'UPDATE E2E RPT MACHINERY DEPRECIATION RATES',
                ]) && (
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(dataInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                )}
                {Acl(permissions, [
                  'DELETE E2E RPT MACHINERY DEPRECIATION RATES',
                ]) && (
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleRemove(dataInfo)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                )}
              </div>
            </div>
            <div className="mt-3 pt-4 border-top">
              <table className="transaction-table table table-borderless table-striped table-sm ">
                <tbody>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      Depreciation Rate
                    </td>
                    <td className="text-dark" width="1" />
                    <td className="text-dark">
                      {_.get(dataInfo, 'attributes.depreciation_rate') || '--'}
                    </td>
                  </tr>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      From
                    </td>
                    <td className="text-dark" width="1" />
                    <td className="text-dark">
                      {_.get(dataInfo, 'attributes.from') || '--'}
                    </td>
                  </tr>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      To
                    </td>
                    <td className="text-dark" width="1" />
                    <td className="text-dark">
                      {_.get(dataInfo, 'attributes.to') || '--'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

DepreciationRateContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Object).isRequired,
  depreciationRateId: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  dataInfo: _.get(api, `${c.SHOW_DATA}.item`) || {},
  depreciationRateId: _.get(match, 'params.depreciationRateId') || '',
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(DepreciationRateContent);
